/**
 * API service for ACQ Collective Communications
 */

import Axios from '.'
import { AxiosConfigType } from '../types'
import { Communication } from '../types/communications'

/**
 * Get all communications that should be displayed in member space
 * @param contactId - Optional contact ID to fetch communications for. If not provided, API will use authenticated user's contact ID
 * @param config - Optional Axios config
 */
const getCommunications = async (contactId?: string | null, config?: AxiosConfigType) => {
  const params: Record<string, any> = { ...config?.params }
  
  // Only add contact_id if provided
  if (contactId) {
    params.contact_id = contactId
  }
  
  const response = await Axios.get<Communication[]>(
    'communication',
    {
      ...config,
      params,
    }
  )
  return response.data
}

/**
 * Get a single communication by ID
 */
const getCommunication = async (id: string, config?: AxiosConfigType) => {
  const response = await Axios.get<Communication>(
    `communication/${id}`,
    config
  )
  return response.data
}

const communicationsApi = {
  getCommunications,
  getCommunication,
}

export default communicationsApi
